import React from 'react'
import { ActivityIndicator } from 'react-native'
import styled from 'styled-components/native'
import NoWorkOrdersNotice from './NoWorkOrdersNotice'
import Show from '@components/Show'
import PendingWorkOrderCard from './PendingWorkOrderCard'
import useNavigation from '@hooks/useNavigation'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.LIST

const Wrapper = styled.View`
  position: relative;
  margin-top: 25px
`

const Header = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const HeaderText = styled.Text`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`

interface PendingWorkOrdersProps {
  loading: boolean
  workOrders: any[]
}

const PendingWorkOrders: React.VFC<PendingWorkOrdersProps> = (props) => {
  const { loading, workOrders } = props
  const navigation = useNavigation()

  return (
    <Wrapper>
      <Header>
        <HeaderText>{COPY.PENDING_REQUESTS}</HeaderText>
      </Header>
      <Show when={!loading} fallback={<ActivityIndicator />}>
        <>
          { workOrders?.map((workOrder, index) => (
            <PendingWorkOrderCard
              key={index}
              workOrder={workOrder}
              onPress={() =>
                navigation.navigate('pendingWorkOrderView', { workOrder })
              }
            />
          ))}
        </>
        <Show when={workOrders?.length === 0}>
          <NoWorkOrdersNotice />
         </Show>
      </Show>
    </Wrapper>
  )
}

export default PendingWorkOrders
